import React from "react";

export const InputEntryName = (props) => {
    const {inputName, inputIndex} = props;
    return (
        <div className="input-name">
            <span className="name">{inputName}</span>
            <span className="input-index">{inputIndex}</span>
        </div>
    );
}